import type { ComponentType } from 'react'
import { ArrowUpRight, FileText } from 'lucide-react'

import { SITE, SOCIALS } from '../data/site'
import type { SocialKind } from '../data/site'
import { GithubIcon, LinkedinIcon } from './BrandIcons'
import { Reveal } from './Reveal'
import { Section } from './Section'
import styles from './Contact.module.css'

const ICONS: Record<SocialKind, ComponentType<{ size?: number }>> = {
  github: GithubIcon,
  linkedin: LinkedinIcon,
}

export function Contact() {
  return (
    <Section
      id="contact"
      eyebrow="Contact"
      title="Let's talk."
      lead="Hiring, collaborating, comparing notes on IoT, or arguing about pressings — the inbox is open."
    >
      <Reveal>
        <ul className={styles.grid}>
          {SOCIALS.map((social) => {
            const Icon = ICONS[social.kind]
            const external = true

            return (
              <li key={social.kind}>
                <a
                  className={styles.card}
                  href={social.href}
                  {...(external ? { target: '_blank', rel: 'me noopener' } : {})}
                >
                  <span className={styles.icon} aria-hidden="true">
                    <Icon size={19} />
                  </span>
                  <span className={styles.text}>
                    <span className={styles.label}>
                      {social.label}
                      {external && (
                        <span className="visually-hidden"> (opens in a new tab)</span>
                      )}
                    </span>
                    <span className={styles.handle}>{social.handle}</span>
                  </span>
                  <ArrowUpRight className={styles.arrow} size={16} aria-hidden="true" />
                </a>
              </li>
            )
          })}
        </ul>
      </Reveal>

      <Reveal delay={120}>
        <div className={styles.resume}>
          <div>
            <h3 className={styles.resumeTitle}>Prefer the one-pager?</h3>
            <p className={styles.resumeBlurb}>
              The full history, roles, and references in a printable form.
            </p>
          </div>
          <a className={styles.resumeLink} href={SITE.resumeHref} target="_blank" rel="noopener">
            <FileText size={17} aria-hidden="true" />
            Download résumé
            <span className="visually-hidden">(HTML, opens in a new tab)</span>
          </a>
        </div>
      </Reveal>
    </Section>
  )
}
